// extracted by mini-css-extract-plugin
export var standaloneTable = "_gp-0";
export var withExtraHeader = "_gp-1";